module.exports = __webpack_public_path__ + "media/audio115.9d1f3e07.mp3";